import { render } from "./clientprofilehead.vue?vue&type=template&id=6e067bb8"
import script from "./clientprofilehead.vue?vue&type=script&lang=js"
export * from "./clientprofilehead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__